import { apiService } from "@/_services";
import { timeParseNull2 } from "@/_core/_helpers/_helpers";

/**
 * Fetches FOMC dot plot data from the API and updates the component state.
 * @param {object} _this - The context object containing state variables.
 */
export async function getDotPlot(_this) {
  // Set loading states to true
  Object.assign(_this.loading, {
    dotPlotProjections: true,
    dotsProjections: true
  });

  const params = {
    method: "GET",
    endpoint: "dot_plot",
    content_type: "application/json",
    query_params: { format: "json" }
  };
  // Fetch data from API
  apiService
    .getAll(params)
    .then(data => {
      parseData(data, _this);
    })
    .catch(function(error) {
      console.error("Error fetching dot plot data:", error);
      // Reset loading state to false in case of an error
      Object.assign(_this.loading, { dotPlotProjections: false });
    });
}

/**
 * Parses the retrieved dot plot data and updates the component state.
 * @param {Array} data - The fetched dot plot data.
 * @param {object} _this - The context object containing state variables.
 */
function parseData(data, _this) {
  const dataDots = [];
  data.forEach((d, index) => {
    // Convert date fields to proper format
    d.objective_date = timeParseNull2(d.objective_date);
    d.update_date = timeParseNull2(d.update_date);
    // Assign unique group and item IDs
    d.groupId = String(new Date(d.objective_date).getFullYear());
    d.id = index;
    // Add dot projections only if name === "dots"
    if (d.name === "dots") {
      dataDots.push(...Array(d.dots).fill(d)); // Push d multiple times based on `dots` count
    }
  });

  // Update state variables
  Object.assign(_this.allData, {
    dotPlotProjections: data,
    dotsProjections: dataDots
  });

  // Reset loading states
  Object.assign(_this.loading, {
    dotPlotProjections: false,
    dotsProjections: false
  });
}
